import { Badge, Col, Dropdown, Modal, Row, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { color } from "../../../resource";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { CardContainer } from "../../../components/Card/CardContainer";

import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";
import { dateFormatter } from "../../../utility/Formatter";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { zoneEntity } from "../../../entities/ZoneEntity";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../../store/RoleAtom";
import { checkPermission } from "../../../components/Permission/Permission";
import icon from "../../../resource/icon";
import SortFieldCustom from "../../../components/SortFieldTable/SortFieldCustom";
import useSorting from "../../../hook/useSorting";
const Header = styled(Col)`
  border-radius: 8px;
  background-color: ${color.background1};
  padding: 20px;
  //display: flex;
  //gap: 16px;
  align-items: center;
  width: "100%";
`;

export const ZoneSettingPage: React.FC = () => {
  const navigate = useNavigate();

  const roleData = useRecoilValue(roleAtom);
  const isCreate = checkPermission(["zoneSetting", "create"], roleData);
  const isEdit = checkPermission(["zoneSetting", "edit"], roleData);

  const [search, setSearch] = useState<string>("");
  const [status, setStatus] = useState<boolean | null | undefined>();
  const [zoneList, setZoneList] = useState<zoneEntity[]>([]);
  const [page, setPage] = useState<number>(1);
  const { sortField, sortDirection, handleSortChange } = useSorting();

  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;

  const getZone = async (
    searchZoneName?: string | null,
    filterIsActive?: boolean | null | undefined,
  ): Promise<zoneEntity[]> => {
    try {
      const res = await zoneDatasource.getAllZoneByCompany(company);
      return searchZone(res, searchZoneName, filterIsActive);
    } catch (error) {
      console.error("Error fetching zone data:", error);
      throw error; // or handle the error as needed
    }
  };

  function searchZone(
    zones: zoneEntity[],
    searchZoneName?: string | null,
    filterIsActive?: string | boolean | null | undefined,
  ): zoneEntity[] {
    return zones.filter((zone) => {
      const matchesZoneName =
        searchZoneName === "" ||
        searchZoneName === undefined ||
        searchZoneName === null ||
        zone.zoneName.toLowerCase().includes(searchZoneName.toLowerCase());
      const matchesIsActive =
        filterIsActive === "all" ||
        filterIsActive === undefined ||
        filterIsActive === null ||
        zone.isActive == (filterIsActive == "inactive" ? false : filterIsActive);
      return matchesZoneName && matchesIsActive;
    });
  }

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const field = sortDirection ? sortField : "updatedAt";
        const filteredZones = await getZone(search, status);
        if (field == "updatedAt") {
          let sortZone = filteredZones;
          if (sortDirection == "ASC") {
            sortZone = filteredZones.sort(
              (a, b) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
            );
          } else {
            sortZone = filteredZones.sort(
              (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
            );
          }
          setZoneList(sortZone);
        } else {
          const sortZone = [...filteredZones].sort((a, b) => {
            const aVal = a[`${field}`];
            const bVal = b[`${field}`];

            if (aVal == null || bVal == null) return 0;

            if (typeof aVal === "number" && typeof bVal === "number") {
              return sortDirection === "DESC" ? bVal - aVal : aVal - bVal;
            }

            return sortDirection === "DESC"
              ? String(bVal).localeCompare(String(aVal))
              : String(aVal).localeCompare(String(bVal));
          });
          setZoneList(sortZone);
        }
      } catch (error) {
        console.error("Error fetching zones:", error);
        throw error;
      }
    };

    fetchZones();
  }, [search, status, sortField, sortDirection]);

  const ActionBtn = ({ onClick, icon }: any) => {
    return (
      <Col span={6}>
        <div className='btn btn-icon btn-light btn-hover-primary btn-sm' onClick={onClick}>
          <span
            className='svg-icon svg-icon-primary svg-icon-2x'
            style={{ color: color["primary"] }}
          >
            {icon}
          </span>
        </div>
      </Col>
    );
  };

  const columns: any = [
    {
      title: (
        <SortFieldCustom
          title='ชื่อเขต'
          sortDirection={sortField === "zoneName" ? sortDirection : undefined}
          onSortChange={() => handleSortChange("zoneName")}
        />
      ),
      dataIndex: "zoneName",
      key: "zoneName",
      width: "30%",
      render: (value: any, row: zoneEntity, index: number) => {
        return {
          children: (
            <>
              <Text level={5}>{row.zoneName}</Text>
            </>
          ),
        };
      },
    },
    {
      title: "ทีม",
      dataIndex: "team",
      key: "team",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text level={5}>{value ? value.teamName : null}</Text>
            </>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              {/* <Badge
                count={row.isActive ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                style={{ backgroundColor: row.isActive ? color.success : color.Disable }}
              /> */}
              <Tag color={row.isActive ? color.success : color.Disable}>
                {row.isActive ? "เปิดใช้งาน" : "ปิดใช้งาน"}
              </Tag>
            </Row>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "shopName",
      key: "shopName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text level={5} fontSize={14}>
                {dateFormatter(row.updatedAt, false)}
              </Text>

              <br />
              <Text level={5} color='Text3'>
                {row.updateBy ? row.updateBy : row.createBy}
              </Text>
            </>
          ),
        };
      },
    },

    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      hidden: !isEdit,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              <Col span={6}>
                <Button
                  onClick={() =>
                    navigate(`/generalSettings/createZoneSetting/${row.zoneId}`, { state: { row } })
                  }
                  typeButton='secondary'
                  icon={<img src={icon.iconEdit} style={{ width: "18px", height: "18px" }} />}
                />
              </Col>
            </Row>
          ),
        };
      },
    },
  ].filter((x) => !x.hidden);

  const PageTitle = (
    <>
      <Row gutter={16}>
        <Col span={20}>
          <Text level={3} fontWeight={700}>
            รายการเขต
          </Text>
        </Col>
        {isCreate && (
          <Col className='gutter-row' span={4}>
            <Button
              title='+ เพิ่มเขต'
              onClick={() => navigate("/generalSettings/createZoneSetting/create")}
            />
          </Col>
        )}
      </Row>
      <br />
      <Row gutter={16}>
        <Col span={18}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อเขต'
            prefix={<SearchOutlined style={{ color: "grey" }} />}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
        </Col>

        <Col span={6}>
          <Select
            allowClear
            defaultValue={"all"}
            placeholder='สถานะ'
            data={[
              { key: "all", value: null, label: "สถานะทั้งหมด" },
              { key: "active", value: true, label: "เปิดใช้งาน" },
              { key: "inactive", value: false, label: "ปิดใช้งาน" },
            ]}
            style={{ width: "100%" }}
            onChange={(e) => {
              setStatus(e);
              setPage(1);
            }}
          />
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <CardContainer>
        {PageTitle}
        <br />
        {/* <Table columns={columns} dataSource={zoneList || []} pagination={false} /> */}
        <Table
          columns={columns}
          dataSource={zoneList || []}
          pagination={{
            position: ["bottomCenter"],
            pageSize: 10,
            current: page,
            total: zoneList.length,
            onChange: (p) => setPage(p),
            showSizeChanger: false,
          }}
        />
      </CardContainer>
    </>
  );
};
